import React from 'react';
import MuiIconButton from '@mui/material/IconButton';
import MUIICon from '@mui/material/Icon';
import {DateRangePickerTestAttributes} from '@famly/mf_util_date-range-picker-test-attributes';

/**
 * The PreviousIconButton "slots" unfortunately types its props as "any". Reflecting that here.
 */
export const PreviousIconButton = (props: any) => {
    return (
        <MuiIconButton
            {...props}
            sx={theme => ({width: 36, height: 36, color: theme.modernFamlyTheme.colorPalette.n400})}
        >
            <MUIICon
                data-e2e-id={DateRangePickerTestAttributes.previousMonthButton}
                sx={{
                    fontSize: `24px`,
                    color: 'inherit',
                }}
            >
                chevron_left
            </MUIICon>
        </MuiIconButton>
    );
};

/**
 * The NextIconButton "slots" unfortunately types its props as "any". Reflecting that here.
 */
export const NextIconButton = (props: any) => {
    return (
        <MuiIconButton
            {...props}
            sx={theme => ({width: 36, height: 36, color: theme.modernFamlyTheme.colorPalette.n400})}
        >
            <MUIICon
                data-e2e-id={DateRangePickerTestAttributes.nextMonthButton}
                sx={{
                    fontSize: `24px`,
                    color: 'inherit',
                }}
            >
                chevron_right
            </MUIICon>
        </MuiIconButton>
    );
};

export const MF_DATE_DIALOG_PADDING = 6;
